export default __webpack_public_path__ + "static/media/Outfit-Medium.1d6f1a86.ttf";